import React from 'react';
import { createIcon } from './create-icon';
import './icon-caret-right.scss';

export const IconCaretRight = createIcon(<div className="icon-caret-right-primary" />);
export const IconCaretRightSecondary = createIcon(<div className="icon-caret-right-secondary" />);
